import type { JSX, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { FEATURE_FLAGS, flagEnabled, useAuth } from "../../hooks/useAuth";

// Gates the customer billing route on the billing_customer flag, separate from
// the admin billing_stripe gate -- so the admin billing console can be on for
// testing while the customer surface stays hidden. Off -> bounce to the
// dashboard overview; the nav entry is already hidden when off, so this only
// catches direct navigation.
export const CustomerBillingGate = ({ children }: { children: ReactNode }): JSX.Element => {
  const { user } = useAuth();
  if (flagEnabled(user?.features, FEATURE_FLAGS.billingCustomer)) return <>{children}</>;
  return <Navigate to="/dashboard/overview" replace />;
};
